import { render, staticRenderFns } from "./IntegralOrderDetail.vue?vue&type=template&id=61c4803a&scoped=true"
import script from "./IntegralOrderDetail.vue?vue&type=script&lang=js"
export * from "./IntegralOrderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c4803a",
  null
  
)

export default component.exports